import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "pr-8 py-8 text-center"
};
const _hoisted_2 = {
  class: "flex justify-center mb-6"
};
const _hoisted_3 = {
  class: "w-20 h-20"
};
const _hoisted_4 = {
  class: "flex items-center justify-center space-x-3"
};
import { useEntriesStore } from '@/services/useEntriesStore';
import M356Logo from '@/components/SVG/M356Logo.vue';
import LlSwitch from '@/components/LlSwitch.vue';
export default {
  __name: 'EnableM365',
  emits: ['cancel'],
  setup(__props, {
    emit: __emit
  }) {
    const entriesStore = useEntriesStore();
    const emit = __emit;
    const enableMicrosoft = async () => {
      await entriesStore.enableMicrosoft();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(M356Logo, {
        class: "w-full h-full"
      })])]), _cache[0] || (_cache[0] = _createElementVNode("h2", {
        class: "text-xl font-semibold text-gray-900 mb-4"
      }, " Microsoft 365 Integration ", -1)), _cache[1] || (_cache[1] = _createElementVNode("p", {
        class: "text-gray-600 text-sm leading-relaxed mb-16 max-w-xs mx-auto"
      }, " Integrate LeanLaw with Microsoft 365 to receive calendar events and add them to LeanLaw as time entries. Save time and enjoy a synchronized experience across commonly-used tools. ", -1)), _createElementVNode("div", _hoisted_4, [_createVNode(LlSwitch, {
        "model-value": false,
        "onUpdate:modelValue": enableMicrosoft,
        class: "flex-shrink-0",
        label: "Enable Microsoft 365"
      })])]);
    };
  }
};